module.exports = __webpack_public_path__ + "img/right_two.904614d7.png";